<script>
    import { mapGetters, mapActions } from 'vuex';
    import { routeNames } from '@app/router/constants';

    export default {
        name: 'ResultTypePicker',
        created() {
            this.fetchAllGames();
        },
        // has to be computed if we want the functionality that the date
        // stays the same when we change virtuals type
        computed: {
            ...mapGetters('data/games', [
                'virtualGames',
                'virtualShopsGames',
            ]),
            selectedItem() {
                return this.items.find((x) => x.isSelected);
            },
            items() {
                const {
                    params: {
                        date: dateParam,
                    },
                    name: routeName,
                } = this.$route;
                const params = {
                    date: dateParam,
                };
                const items = [{
                    label: 'sport',
                    to: { name: routeNames.sportResults, params },
                    isSelected: routeName === routeNames.sportResults,
                }, {
                    label: 'live',
                    to: { name: routeNames.liveResults, params },
                    isSelected: routeName === routeNames.liveResults,
                }, {
                    label: 'lotto',
                    to: { name: routeNames.lottoResults, params },
                    isSelected: (routeName === routeNames.lottoResults
                        || routeName === routeNames.lottoGameResults
                        || routeName === routeNames.lottoSystemResults)
                }, {
                    label: 'special',
                    to: { name: routeNames.specialsResults, params },
                    isSelected: routeName === routeNames.specialsResults,
                }];
                if (this.virtualShopsGames.length) {
                    items.push({
                        label: 'shops',

                        to: {
                            name: routeNames.virtualShopsResults,
                            params: {
                                ...params,
                                gameType: this.virtualShopsGames[0].name,
                            }
                        },
                        isSelected: routeName === routeNames.virtualShopsResults,
                    });
                }
                if (this.virtualGames.length) {
                    items.push({
                        label: 'virtual',

                        to: {
                            name: routeNames.virtualResults,
                            params: {
                                ...params,
                                gameType: this.virtualGames[0].name,
                            }
                        },
                        isSelected: routeName === routeNames.virtualResults,
                    });
                }
                return items;
            },
        },
        methods: mapActions('data/games', [
            'fetchAllGames',
        ]),
        render() {
            return this.$scopedSlots.default({
                items: this.items,
                selectedItem: this.selectedItem,
            });
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Results/ResultsTypePickerContainer.vue